export { adminBuildInfoEndpoints } from './buildInfo';
export type {
  SystemBuildInfoBuildBlockDto,
  SystemBuildInfoGitBlockDto,
  SystemBuildInfoInstanceDto,
  SystemBuildInfoServiceDto,
  SystemBuildInfoDto,
} from './buildInfo';

export { adminDbPoolEndpoints } from './dbPool';
export type {
  DbPoolEntryDto,
  DbServerStatsDto,
  DbProcessEntryDto,
  DbPoolStatsDto,
} from './dbPool';

export { adminLoggersEndpoints } from './loggers';
export type {
  LoggerLevelDto,
  SystemLoggersInstanceDto,
  SystemLoggersServiceDto,
  SystemLoggersDto,
  SetLoggerLevelRequestDto,
} from './loggers';

export { adminLogfileEndpoints } from './logfile';

import { adminBuildInfoEndpoints } from './buildInfo';
import { adminDbPoolEndpoints } from './dbPool';
import { adminLoggersEndpoints } from './loggers';
import { adminLogfileEndpoints } from './logfile';

export const adminSystemEndpoints = {
  ...adminBuildInfoEndpoints,
  ...adminDbPoolEndpoints,
  ...adminLoggersEndpoints,
  ...adminLogfileEndpoints,
};
